import { Box, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Paper from "common/components/Paper";
import Typography from "common/components/Typography";

const getIsPortrait = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return window.innerHeight > window.innerWidth;
};

type OrientationGuardProps = {
  children: React.ReactNode;
};

const OrientationGuard = ({ children }: OrientationGuardProps) => {
  const { t } = useTranslation();
  const [isPortrait, setIsPortrait] = useState(getIsPortrait);

  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(getIsPortrait());
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  if (!isPortrait) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        p: 3,
        zIndex: 1300,
      }}
    >
      <Paper sx={{ width: "min(100%, 28rem)", textAlign: "center" }}>
        <Stack spacing={2} alignItems="center">
          <Typography size="l">{t("Tourne ton appareil")}</Typography>
          <Typography size="m">
            {t(
              "ADA nécessite un affichage en mode paysage. Retourne ton appareil pour continuer.",
            )}
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
};

export default OrientationGuard;
